export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
};

export const dmLink = (contact, text, subject = "you're in: nobo run club") => {
  const c = (contact || "").trim();
  if (/^\S+@\S+\.\S+$/.test(c)) return `mailto:${c}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`;
  const handle = c.replace(/^@/, "").replace(/^https?:\/\/(www\.)?instagram\.com\//, "").replace(/\/.*$/, "");
  return /^[\w.]{1,30}$/.test(handle) ? `https://ig.me/m/${handle}` : null;
};
